const appId = Object.freeze({
  PIX: 1,
});

export default appId;
